import { render, staticRenderFns } from "./DetailGenerator.vue?vue&type=template&id=468be050&scoped=true"
import script from "./DetailGenerator.vue?vue&type=script&lang=js"
export * from "./DetailGenerator.vue?vue&type=script&lang=js"
import style0 from "./DetailGenerator.vue?vue&type=style&index=0&id=468be050&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468be050",
  null
  
)

export default component.exports